<template>
  <div class="card-modal-setting-wrapper">
    <div class="switch-group">
      <div class="group-right">
        <img
          src="@/assets/img/form-builder-icons/option-modal-switch-icon.svg"
          alt="icon"
        />

        <label class="caption">Fenster mit Zusatzinformationen</label>
      </div>
      <CommonSwitch
        v-model="option.isModalVisible"
        :isDisabled="!isUserHasAccess"
        @onChange="onChangeModalVisible"
        class="medium-size"
        :colorMap="{ off: '#CCCCCC', on: '#484E5E' }"
      />
    </div>
    <div v-if="option.isModalVisible" class="modal-detail-wrapper">
      <div class="link-wrapper">
        <EditableInputDiv
          class="modal-link-input"
          v-model="option.modalConfig.modalLink"
          :required="true"
        />
        <img
          @click="toggleCollapse"
          src="@/assets/img/angle-arrow-down.svg"
          alt="icon"
        />
      </div>
      <b-collapse v-model="isShowCollapse">
        <b-card class="p-0 border-0">
          <div class="modal-header p-0 border-0">
            <label>Position</label>
          </div>
          <div class="modal-container">
            <div class="button-wrapper">
              <b-button
                :class="{ active: getModalPosition === 'left' }"
                @click="onChangePosition('left')"
              >
                <img
                  v-if="getModalPosition === 'left'"
                  src="@/assets/img/form-builder-icons/option-card-left-active-modal-icon.svg"
                  alt="icon"
                />
                <img
                  v-else
                  src="@/assets/img/form-builder-icons/option-card-left-modal-icon.svg"
                  alt="icon"
                />
                <span>Links</span>
              </b-button>
              <b-button
                :class="{ active: getModalPosition === 'middle' }"
                @click="onChangePosition('middle')"
              >
                <img
                  v-if="getModalPosition === 'middle'"
                  src="@/assets/img/form-builder-icons/option-card-center-active-modal-icon.svg"
                  alt="icon"
                />
                <img
                  v-else
                  src="@/assets/img/form-builder-icons/option-card-center-modal-icon.svg"
                  alt="icon"
                />
                <span>Mitte</span>
              </b-button>
              <b-button
                :class="{ active: getModalPosition === 'right' }"
                @click="onChangePosition('right')"
              >
                <img
                  v-if="getModalPosition === 'right'"
                  src="@/assets/img/form-builder-icons/option-card-right-active-modal-icon.svg"
                  alt="icon"
                />
                <img
                  v-else
                  src="@/assets/img/form-builder-icons/option-card-right-modal-icon.svg"
                  alt="icon"
                />
                <span>Rechts</span>
              </b-button>
            </div>

            <div
              class="preview-wrapper position-relative"
              :class="getModalPosition"
            >
              <div class="preview-card">
                <div class="preview-content">
                  <h6>Title</h6>
                  <p>
                    Lorem ipsum dolor sit amet consectetur. In justo dolor
                    pretium neque. At justo dolor pretium nequepretium neque. At
                    justo dolor pretium neque pretium neque. At justo dolo
                  </p>
                </div>
                <div
                  class="preview-image border d-flex align-items-center justify-content-center"
                >
                  <img src="@/assets/img/image-icon.svg" />
                </div>
              </div>
              <img
                @click="toggleCardEditor"
                class="link-icon position-absolute"
                src="@/assets/img/link-icon.svg"
              />
            </div>
          </div>
          <CardModalEditor
            v-if="iscardEditorOpen"
            :option="option"
            :isUserHasAccess="isUserHasAccess"
            @close="toggleCardEditor"
          />
        </b-card>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import CardModalEditor from '../elements/CardModalEditor.vue';
import CommonSwitch from '../../widgets/CommonSwitch.vue';
import EditableInputDiv from '@/components/core/EditableInputDiv.vue';
export default {
  name: 'optionCardModalSettingsPanel',
  data() {
    return {
      enabled: true,
      position: 'middle',
      linkText: 'Mehr Infos',
      iscardEditorOpen: false,
      isShowCollapse: false,
    };
  },
  props: {
    element: Object,
    option: Object,
    isUserHasAccess: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    toggleCardEditor() {
      this.iscardEditorOpen = !this.iscardEditorOpen;
    },
    toggleCollapse() {
      this.isShowCollapse = !this.isShowCollapse;
    },
    onChangeModalVisible() {
      this.isShowCollapse = false;
    },
    onChangePosition(position) {
      if (position)
        this.$set(this.element.settings, 'optionModalPosition', position);
    },
  },
  computed: {
    getModalPosition() {
      return this.element.settings.optionModalPosition;
    },
  },
  components: { CardModalEditor, CommonSwitch, EditableInputDiv },
};
</script>

<style scoped>
.card-modal-setting-wrapper {
  padding-top: 10px;
}
.card-modal-setting-wrapper .switch-group {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.card-modal-setting-wrapper .switch-group .group-right {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}
.card-modal-setting-wrapper .switch-group .group-right img {
  width: 13px;
  height: 13px;
}
.card-modal-setting-wrapper .switch-group .caption {
  font-family: 'OpenSans-Regular';
  padding: 0;
  margin: 0;
  color: #555b6a;
  font-size: 13px;
  line-height: 27px;
  letter-spacing: -0.02em;
  box-shadow: none;
}

.card-modal-setting-wrapper .link-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 11px;
  background: #ffffff;
  border: none;
  padding: 3px 25px;
  box-shadow: none;
  height: 36px;
  cursor: default;
}
.card-modal-setting-wrapper .link-wrapper .modal-link-input {
  color: #5f697a;
  font-family: 'OpenSans-Regular';
  line-height: 36px;
  letter-spacing: -0.02em;
  font-size: 13px;
  font-weight: 400;
  text-decoration: underline;
  padding: 0;
  border: none;
  margin: 0;
  overflow: hidden;
}
.card-modal-setting-wrapper .link-wrapper img {
  transition: 0.1s ease-in-out;
  color: #484e5e;
  cursor: pointer;
}
.card-modal-setting-wrapper .modal-detail-wrapper:has(.show) .link-wrapper img {
  transform: rotate(180deg);
}
.card-modal-setting-wrapper .preview-image {
  width: 80px;
  height: 60px;
  background: #eee;
}

.card-modal-setting-wrapper .card .card-body {
  padding: 0;
}

.card-modal-setting-wrapper .card .modal-header label {
  font-family: 'OpenSans-SemiBold';
  padding: 0;
  padding-bottom: 17px;
  font-size: 13px;
  color: #555b6a;
  line-height: 27px;
  letter-spacing: -0.02em;
  font-weight: 600;
}

.card-modal-setting-wrapper .card .button-wrapper {
  display: flex;
  gap: 8px;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 29px;
}
.card-modal-setting-wrapper .card .button-wrapper button {
  border: 0.7px solid #d9dbdc;
  height: 33px;
  width: 95px;
  border-radius: 16.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  background-color: #ffffff;
  transition: all 0.2 ease;
}
.card-modal-setting-wrapper .card .button-wrapper button.active {
  background-color: #484e5e;
}
.card-modal-setting-wrapper .card .button-wrapper button span {
  font-family: 'OpenSans-SemiBold';
  font-size: 13px;
  color: #484e5e;
  line-height: 36px;
  letter-spacing: -0.02em;
  font-weight: 600;
}
.card-modal-setting-wrapper .card .button-wrapper button.active span {
  color: #ffffff;
}
.card-modal-setting-wrapper .card .preview-wrapper {
  border-radius: 10px;
  padding: 26px 30px;
  width: 305px;
  height: 178px;
  background-color: rgba(30, 30, 30, 0.2);
}
.card-modal-setting-wrapper .card .preview-wrapper .preview-card {
  background-color: #ffffff;
  padding: 17px 17px 26px;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-direction: row;
  transition: all 0.2 ease;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
}
.card-modal-setting-wrapper .card .preview-card .preview-content {
  display: flex;
  flex-direction: column;
  width: 101px;
}
.card-modal-setting-wrapper .card .preview-card .preview-content h6 {
  font-family: 'OpenSans-SemiBold';
  font-size: 12px;
  color: #484e5e;
  line-height: 27px;
  letter-spacing: -0.02em;
  font-weight: 600;
  margin: 0;
}
.card-modal-setting-wrapper .card .preview-card .preview-content p {
  font-family: 'OpenSans-Regular';
  font-size: 7px;
  color: #555b6a;
  line-height: 9px;
  letter-spacing: -0.03em;
  font-weight: 400;
  margin: 0;
}

.card-modal-setting-wrapper .card .preview-card .preview-image {
  width: 104px;
  height: 72px;
  background: #ececf0;
  border-radius: 5px;
}

/* right-side preview css changes */

.card-modal-setting-wrapper .card .preview-wrapper.left,
.card-modal-setting-wrapper .card .preview-wrapper.right {
  padding: 0;
  display: flex;
  justify-content: end;
}
.card-modal-setting-wrapper .card .preview-wrapper.left .preview-card,
.card-modal-setting-wrapper .card .preview-wrapper.right .preview-card {
  width: 153px;
  height: 100%;
  padding: 13px 20px 17px;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.card-modal-setting-wrapper .card .preview-wrapper.left .preview-image,
.card-modal-setting-wrapper .card .preview-wrapper.right .preview-image {
  width: 100%;
  height: 55px;
}
.card-modal-setting-wrapper .card .preview-wrapper.left .preview-content,
.card-modal-setting-wrapper .card .preview-wrapper.right .preview-content {
  width: 100%;
}

/* left-side preview css changes */
.card-modal-setting-wrapper .card .preview-wrapper.left {
  justify-content: start;
}

.card-modal-setting-wrapper .card .preview-wrapper.left .preview-card {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.card-modal-setting-wrapper .card .preview-wrapper .link-icon {
  top: 13px;
  right: 13px;
  cursor: pointer;
}
</style>
